import { Button } from "@/lib/components/Button/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/lib/components/Dialog";

type SuggestAnimationsDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading: boolean;
};

export function SuggestAnimationsDialog({
  isOpen,
  onOpenChange,
  onConfirm,
  isLoading,
}: SuggestAnimationsDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader className="w-full">
          <DialogTitle>Apply suggested animations?</DialogTitle>
          <DialogDescription>
            Amplifiles analyzes your images and sets suggested animations
            automatically. This will replace any animations you've already
            selected.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onConfirm} disabled={isLoading}>
            {isLoading ? "Applying..." : "Apply suggestions"}
          </Button>
          <DialogClose asChild>
            <Button type="button" variant="outline" disabled={isLoading}>
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
